import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import SelectedTick from "../../../../assets/images/selected-tick.svg";
const StyledAgeGroup = styled.div`
    &.dropdown-mini,
    &.dropdown-mini * {
        box-sizing: border-box;
    }
    &.dropdown-mini {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 246px;
        position: relative;
        box-shadow: var(--dropdown-ds-box-shadow, 0px 0px 10px 0px rgba(17, 22, 32, 1));
        position: absolute;
        z-index: 9;
        margin-top: 5px;
    }
    .frame-75 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-79 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-313638 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .all {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-84 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox2 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-1 {
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .frame-313639 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .babies-0-2-yo {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-86 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .frame-86:hover {
        background: var(--surface-surface-tertiary-hover, #282828);
    }
    .toddlers-3-4-yo {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-87 {
        background: var(--surface-surface-tertiary-hover, #282828);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .kids-5-12 {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-88 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .teenagers-13-19-yo {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-89 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .young-adults-20-35-yo {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-3136392 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .btn-xs-primary {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
export default function AgeGroup({
    selectedTypes = [], // Ensure selectedTypes is an array
    setSelectedTypes,
    setShowImageType,
    setShowGenderFilter,
    setShowAgeGroupFilter,
    searchFunction
}) {
    const navigate = useNavigate();

    const toggleAgeGroup = ageGroup => {
        let newSelectedTypes;
        const searchParams = new URLSearchParams(window.location.search);
        if (ageGroup === "All") {
            newSelectedTypes = selectedTypes.includes("All") ? [] : ["All"];
            searchParams.delete("agegroup");
        } else {
            newSelectedTypes = selectedTypes.includes(ageGroup)
                ? selectedTypes.filter(type => type !== ageGroup)
                : [...selectedTypes.filter(type => type !== "All"), ageGroup];
            searchParams.set("agegroup", newSelectedTypes.join(","));
        }
        setSelectedTypes(newSelectedTypes);
        navigate({ search: searchParams.toString() });
    };

    return (
        <StyledAgeGroup className="dropdown-mini">
            <div className="frame-75">
                <div className="frame-86" onClick={() => toggleAgeGroup("All")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedTypes.includes("All") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                        </div>
                    </div>
                    <div className="frame-313638">
                        <div className="all">All</div>
                    </div>
                </div>
                <div className="frame-86" onClick={() => toggleAgeGroup("Babies (0-2 yo)")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedTypes.includes("Babies (0-2 yo)") && (
                                <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />
                            )}
                        </div>
                    </div>
                    <div className="frame-313639">
                        <div className="babies-0-2-yo">Babies (0-2 yo)</div>
                    </div>
                </div>
                <div className="frame-86" onClick={() => toggleAgeGroup("Toddlers (3-4 yo)")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedTypes.includes("Toddlers (3-4 yo)") && (
                                <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />
                            )}
                        </div>
                    </div>
                    <div className="frame-313639">
                        <div className="toddlers-3-4-yo">Toddlers (3-4 yo)</div>
                    </div>
                </div>
                <div className="frame-86" onClick={() => toggleAgeGroup("Kids (5-12)")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedTypes.includes("Kids (5-12)") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                        </div>
                    </div>
                    <div className="frame-313639">
                        <div className="kids-5-12">Kids (5-12)</div>
                    </div>
                </div>
                <div className="frame-86" onClick={() => toggleAgeGroup("Teenagers (13-19 yo)")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedTypes.includes("Teenagers (13-19 yo)") && (
                                <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />
                            )}
                        </div>
                    </div>
                    <div className="frame-313639">
                        <div className="teenagers-13-19-yo">Teenagers (13-19 yo)</div>
                    </div>
                </div>
                <div className="frame-86" onClick={() => toggleAgeGroup("Young Adults (20-35 yo)")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {selectedTypes.includes("Young Adults (20-35 yo)") && (
                                <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />
                            )}
                        </div>
                    </div>
                    <div className="frame-313639">
                        <div className="young-adults-20-35-yo">Young Adults (20-35 yo)</div>
                    </div>
                </div>
            </div>
            <div className="frame-3136392">
                <div
                    className="btn-xs-primary"
                    onClick={e => {
                        e.stopPropagation();
                        setShowAgeGroupFilter(false);
                        searchFunction();
                    }}>
                    <div className="button">Done</div>
                </div>
            </div>
        </StyledAgeGroup>
    );
}
